module.exports = __webpack_public_path__ + "static/media/grx.e3ce2dc8.svg";